export const localStorageKeys = {
	token: "token",
};
